<template>
  <div>
    <unicom-modal-acao
      v-model="mostrarModalConfirmar"
      :larguraModal="$store.getters.getLarguraModalConfirmar"
      :textoTitulo="$store.getters.getTituloModalConfirmar"
      :mensagem="$store.getters.getMensagemModalConfirmar"
      :textoBotaoConfirmar="$store.getters.getTextoBotaoModalConfirmar"
      :tipoBotao="$store.getters.getTipoBotaoModalConfirmar"
      :larguraBotaoConfirmar="$store.getters.getLarguraBotaoModalConfirmar"
      @botao-confirmar="$store.getters.getCallbackModalConfirmar"
    />
    <unicom-modal-erro
      v-model="mostrarModalErro"
      :codigoErro="$store.getters.objetoErro.codigoErro"
      :mensagemErro="$store.getters.objetoErro.mensagemErro"
    />
    <unicom-modal-loading v-model="mostrarModalLoading" />
    <unicom-modal-sucesso
      v-model="mostrarModalSucesso"
      titulo="Sucesso!"
      :subtitulo="$store.getters.getSubtituloSucesso"
    />
  </div>
</template>

<script>
export default {
  computed: {
    mostrarModalLoading: {
      get() {
        return this.$store.getters.getLoadingModal;
      },
      set(value) {
        this.$store.commit("setLoadingModal", value);
      }
    },
    mostrarModalErro: {
      get() {
        return this.$store.getters.objetoErro.mostrarErro;
      },
      set(value) {
        if (this.mostrarModalErro === value) return;

        this.$store.commit("setErro", { mostrarErro: value });

        if (!value) {
          this.$store.commit("setLimparCallbacksErro");
        }
      }
    },
    mostrarModalSucesso: {
      get() {
        return this.$store.getters.getMostrarSucessoModal;
      },
      set(value) {
        if (this.mostrarModalSucesso === value) return;

        this.$store.commit("setMostrarSucessoModal", value);

        if (!value) {
          this.$store.commit("setLimparCallbacksSucesso");
        }
      }
    },
    mostrarModalConfirmar: {
      get() {
        return this.$store.getters.getMostrarModalConfirmar;
      },
      set(value) {
        if (this.mostrarModalConfirmar === value) return;
        this.$store.commit("setMostrarModalConfirmar", value);
        if (!value) {
          this.$store.commit("setLimparCallbacksConfirmar");
        }
      }
    }
  }
};
</script>

<style></style>
